"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var OverlayWrapper = (0, _styledComponents.default)('div').withConfig({
  displayName: "Overlay__OverlayWrapper",
  componentId: "sc-1vfkge5-0"
})({
  opacity: 0.5,
  width: '100%',
  height: '100%',
  position: 'fixed',
  top: 0,
  left: 0
}, _styledSystem.color, _styledSystem.layout, _styledSystem.position);

var Overlay = function Overlay(props) {
  var rest = (0, _extends2.default)({}, props);
  return _react.default.createElement(OverlayWrapper, (0, _extends2.default)({
    backgroundColor: "sonar"
  }, rest));
};

exports.Overlay = Overlay;